$(function(){
	if ($(".js-header-hide").length){
		var navHeight = $('.js-header-hide').height(),
			navHidden = false,
			oldScroll = 0;

		$window.on('scroll', function(e){
			e.preventDefault();

			if ((scrollTop > navHeight)&&(!navHidden)&&(oldScroll <= scrollTop)) {
				navHidden = true;
				$(".js-header-hide").addClass('nav-fixed');
				$(".js-basket-nav").addClass('nav-fixed');
			} else if ((scrollTop <= navHeight)||(oldScroll > scrollTop)) {
				navHidden = false;
				$(".js-header-hide").removeClass('nav-fixed');
				$(".js-basket-nav").removeClass('nav-fixed');
			}

			oldScroll = scrollTop;

		})
	}
});

$(function(){
	if ($(".js-header-hide-res").length && ww <= 769){
		var navHeight = $('.js-header-hide-res').height(),
			navHidden = false,
			oldScroll = 0;

		$window.on('scroll', function(e){
			e.preventDefault();

			if ((scrollTop > navHeight)&&(!navHidden)&&(oldScroll <= scrollTop)) {
				navHidden = true;
				$(".js-header-hide-res").addClass('nav-fixed');
			} else if ((scrollTop <= navHeight)||(oldScroll > scrollTop)) {
				navHidden = false;
				$(".js-header-hide-res").removeClass('nav-fixed');
			}

			oldScroll = scrollTop;

		})
	}
});